import { render, staticRenderFns } from "./internalDispatch.vue?vue&type=template&id=c7494470&"
import script from "./internalDispatch.vue?vue&type=script&lang=js&"
export * from "./internalDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports